export default __webpack_public_path__ + "locales/ru/Files.json?hash=6dd91e741baf87527a4a8464f5bc7cf9";